import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import { Grid } from '@mui/material';
import { increaseNftView } from 'APIs/HotAuctionApi';
import { useAppSelector, useDebounce } from 'app/hooks';
import NftTimer from 'components/atoms/Timer/NftTimer';
import AppTooltip from 'components/atoms/Tooltip';
import Header from 'components/organisms/Header/HomeHeader';
import { selectAuth } from 'features/auth/authSlice';
import { selectNft, setNftIndex } from 'features/auth/nftSlice';
import { NftType } from 'interfaces/NftData.interface';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Player from './NftPlayer';
import OwnersCollectors from './OwnersCollectors';
import './styles.css';

const ExploreNft = () => {
  const nftState = useAppSelector(selectNft);
  const authState = useAppSelector(selectAuth);
  const location = useLocation();
  const dispatch = useDispatch();
  const currentIndex = nftState.nftIndex;
  const currentNft = nftState.nfts && nftState.nfts[currentIndex];
  const setCurrentIndex = (idx: number) => dispatch(setNftIndex(idx));
  const [mousePos, setMousePos] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const [fade, setFade] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const toggleFade = (e: MouseEvent) => {
      setFade(false);
      setMousePos({
        x: e.clientX,
        y: e.clientY,
      });
    };
    document.addEventListener('mousemove', toggleFade);
    return () => {
      document.removeEventListener('mousemove', toggleFade);
    };
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    if (nftState.nfts) {
      setCurrentIndex(Math.floor(Math.random() * 1));
    }
    //eslint-disable-next-line
  }, []);

  useDebounce(
    () => {
      setFade(true);
    },
    [mousePos],
    2000
  );

  useEffect(() => {
    if (nftState.nfts && nftState.nfts[currentIndex]) {
      // console.log('currentIndex', currentIndex);
      window.history.replaceState(
        null,
        'Buku',
        `/explore/nft/${nftState.nfts[currentIndex].id}`
      );
      const addView = async () => {
        try {
          if (nftState.nfts)
            await increaseNftView(nftState.nfts[currentIndex].id);
        } catch (error) {
          console.log(error);
        }
      };
      addView();
    }
    //eslint-disable-next-line
  }, [currentIndex, nftState]);

  useEffect(() => {
    const id = location.pathname.split('/')[3];
    if (nftState.nfts && id) {
      const index = nftState.nfts.findIndex(nft => nft.id === +id);
      setCurrentIndex(index);
    }
    //eslint-disable-next-line
  }, [location.pathname, nftState.nfts]);

  // const IconFeatherLa = require('assets/icons/Icon feather-la.png');
  // const IconFeatherLo = require('assets/icons/Icon feather-lo.png');
  const IconFeatherGr = require('assets/icons/Icon feather-gr.png');

  function isNftEnded(timestamp: any) {
    const now = new Date();
    const targetDate = new Date(timestamp);

    return targetDate > now;
  }

  return (
    <>
      <Header />
      <div className="explore-container">
        <div className="explore-container-body">
          {/* <Grid
            sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: 5 }}
          >
            <Button
              onClick={() => {
                navigate('/explore/nft');
              }}
              startIcon={<img src={IconFeatherLa} alt="icon" />}
              type="submit"
              style={{
                color: 'white',
                textDecoration: 'none',
                borderRadius: '16px',
                fontSize: '13px',
                textTransform: 'none',
                backgroundColor: '#ddb930',
                fontWeight: 'bold',
                width: '180px',
                height: '47px',
                alignSelf: 'center',
                boxShadow: 'none',
                opacity: 1,
              }}
            >
              Collectables
            </Button>
            <NormalButton
              Icon={
                <img
                  style={{ marginRight: '10px' }}
                  src={IconFeatherLo}
                  alt="icon"
                />
              }
              text={'Off the record'}
              onClick={() => {
                navigate('/explore/otr');
              }}
              sx={{ width: '180px', height: '47px' }}
            />
          </Grid> */}

          <div className="player-container">
            {currentNft && (
              <Player
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                fade={fade}
                setFade={setFade}
                nft={currentNft}
              />
            )}
          </div>
          <div style={{ opacity: fade ? 0 : 1 }} className="details-container">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h1>{currentNft?.title}</h1>

              <div>
                {currentNft?.categories.map((category, i) => {
                  return (
                    <p
                      style={{
                        backgroundColor: '#36899f',
                        borderRadius: '100px',
                        display: 'inline-block',
                        padding: '0.5em 0em 0.5em 0em',
                        width: '195.3px',
                        whiteSpace: 'nowrap',
                        textDecoration: 'none',
                        margin: 2,
                        textAlign: 'center',
                      }}
                    >
                      <img
                        src={IconFeatherGr}
                        alt="icon"
                        style={{ marginRight: 5 }}
                      />
                      {NftType[category]}
                    </p>
                  );
                })}
              </div>
            </div>

            <p>{currentNft?.description}</p>
            {nftState.nfts?.length && (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '25px',
                  }}
                >
                  <div style={{ display: 'flex' }}>
                    <div>
                      <PlayArrowOutlinedIcon />
                    </div>
                    <div>{currentNft?.views}</div>
                  </div>
                  <div style={{ display: 'flex', opacity: 0.5 }}>
                    <AutoAwesomeOutlinedIcon />
                    <AppTooltip
                      color="white"
                      text="Elo is our ranking system that shows creators how the content is doing on Buku. This is our way to move towards a platform that helps be more transparent."
                    />
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div>
                      <MusicNoteOutlinedIcon />
                    </div>
                    <div>Original audio {currentNft?.username}</div>
                  </div>
                </div>

                {currentNft && <OwnersCollectors user={currentNft?.user} />}
                <Grid>
                  <div
                    onClick={() => {
                      navigate(`/nft-details/${currentNft?.id}`);
                    }}
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '19px',
                      width: '70%',
                      fontSize: '15px',
                      textTransform: 'none',
                      backgroundColor: '#ddb930',
                      fontWeight: 'bold',
                      padding: '10px 15px 10px 15px',
                      textAlign: 'center',
                      boxShadow: 'none',
                      opacity: '1',
                      fontFamily: 'lato',
                      cursor: 'pointer',
                    }}
                  >
                    {currentNft?.endsAt && isNftEnded(currentNft?.endsAt)
                      ? `LIVE AUCTION  ${(<NftTimer nft={currentNft} />)} LEFT`
                      : 'View Collectable'}
                  </div>
                </Grid>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExploreNft;
